<template>
  <div class="c--partner-with-us_airalo-partner-hub_looking-for-more-custom">
    <div class="new-container mx-auto">
      <div class="looking-for-more-custom">
        <div class="looking-for-more-custom-texts">
          <h2 class="looking-for-more-custom-title">
            {{ $t('components.looking.for.more.custom.title') }}
          </h2>
          <i18n path="components.looking.for.more.custom.subtitle" class="looking-for-more-custom-subtitle" tag="p" />
        </div>

        <a
          target="_blank"
          href="https://partners.airalo.com/onboarding/contact-us"
          class="call-to-action light tw-w-auto tw-mt-5 tw-py-4 tw-px-5 tw-flex tw-justify-center tw-items-center hover:tw-no-underline"
        >
          {{ $t('components.looking.for.more.custom.cta-button') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'looking-for-more-custom',
  }
</script>

<style lang="scss" scoped>
  .looking-for-more-custom {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border-radius: 22px;
    background: url('/assets/images/partner-with-us/contact-bottom-banner-partner-hub.png') no-repeat center;
    background-size: cover;
    box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.15);
    height: 408px;
    padding: 20px;

    &-texts {
      max-width: 446px;
    }

    &-title {
      color: #4a4a4a;
      font-size: 27px;
      font-weight: 600;
      letter-spacing: -0.5px;
      line-height: 32px;
      text-align: center;
      margin-bottom: 0;
    }

    &-subtitle,
    &-subtitle a {
      color: #4a4a4a;
      font-size: 15px;
      letter-spacing: 0;
      line-height: 21px;
      text-align: center;
      margin: 20px 0 0;

      a {
        text-decoration: underline;
      }
    }
  }
</style>
